import { VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import { NotifyHelper } from 'vue-kit'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import DeliveryPointsService from '@/services/DeliveryPointsService'
import deliveryStore from '@/stores/DeliveryStore'
import { Errors } from '@/dto/ErrorsResponse'

@DynamicModule
class DeliveryPointsStore extends VuexModule {
  public deliveryPoints: DeliveryPoint[] = []
  public deliveryPointId: number | null = null
  public validationErrors: Errors = {}

  deliveryStore = deliveryStore

  get deliveryId(): number {
    return this.deliveryStore.deliveryId as number
  }

  get deliveryPoint(): DeliveryPoint | null {
    if (!this.deliveryPointId) {
      return null
    }

    return (
      this.deliveryPoints.find(point => point.id === this.deliveryPointId) ||
      null
    )
  }

  get hasErrors(): boolean {
    return Object.keys(this.validationErrors).length > 0
  }

  @Mutation
  selectDeliveryPoint(pointId: number | null) {
    this.deliveryPointId = pointId
  }

  @Mutation
  setDeliveryPoints(points: DeliveryPoint[]) {
    this.deliveryPoints = points
  }

  @Mutation
  addDeliveryPointToList(deliveryPoint: DeliveryPoint) {
    this.deliveryPoints.unshift(deliveryPoint)
  }

  @Mutation
  deleteZoneFromList(deliveryPointId: number) {
    const index = this.deliveryPoints.findIndex(
      point => point.id === deliveryPointId
    )
    this.deliveryPoints.splice(index, 1)
  }

  @Mutation
  public updateDeliveryPointInList(model: DeliveryPoint) {
    const index = this.deliveryPoints.findIndex(
      deliveryPoint => deliveryPoint.id === model.id
    )
    this.deliveryPoints.splice(index, 1, model)
  }

  @Mutation
  public setErrors(errors: Errors) {
    this.validationErrors = errors
  }

  @Action({ rawError: true })
  async saveDeliveryPoint(model: DeliveryPoint) {
    return DeliveryPointsService.savePoint(this.deliveryId, model)
      .then((deliveryPoint: DeliveryPoint) => {
        if (model.id) {
          this.updateDeliveryPointInList(deliveryPoint)
        } else {
          this.addDeliveryPointToList(deliveryPoint)
        }
      })
      .catch(error => {
        throw error.response.data.errors
      })
  }

  @Action({ rawError: true })
  async deleteDeliveryPoint(deliveryPointId: number) {
    return DeliveryPointsService.deletePoint(deliveryPointId)
      .then(() => this.deleteZoneFromList(deliveryPointId))
      .catch(() => {
        NotifyHelper.error('Ошибка сервера')
      })
  }

  @Action({ rawError: true })
  async loadDeliveryPoints() {
    return DeliveryPointsService.getPoints(this.deliveryId as number)
      .then(deliveryPoints => {
        this.setDeliveryPoints(deliveryPoints)
      })
      .catch(() => {
        NotifyHelper.error('Ошибка сервера')
      })
  }
}

export default getModule(DeliveryPointsStore)
